import { jsx as _jsx } from "react/jsx-runtime";
import { useEstimationResult } from '@estimation/entities/estimationSolution';
import { PlotTile } from './PlotTile';
import { useTranslation } from 'react-i18next';
import { useMetricSystem } from '@shared-app/hooks';
export function TotalWeightTile() {
    const { estimationData } = useEstimationResult();
    const { t } = useTranslation();
    const { isImperial } = useMetricSystem();
    return (_jsx(PlotTile, { color: "primary", title: t('Predicted Weight'), value: `${estimationData.prediction.estimated_weight.toString()} ${isImperial ? 'lb' : 'kg'}` }));
}
